import { BaseApiRequestModel } from "../Core";
import BaseApi from "../Core/BaseApi";
import { Notification } from "../Entity/Notification"

export default class NotificationDataAccess extends BaseApi {
    public static GetAllByAdminUserId(Model: NotificationGetAllRequestEntity) {
        return this.BaseGetRequestFreshAsync<Notification[]>("Notification/GetAllByAdminUserId", Model);
    }
    public static MarkRead(Model: NotificationMarkReadRequestEntity) {
        return this.BasePostRequestAsync<Notification>("Notification/MarkRead", Model);
    }
}

export class NotificationGetAllRequestEntity extends BaseApiRequestModel {
    LastNotificationId?: string;
    ShowAll: boolean = false;
    IsFullRefresh: boolean = false
}

export class NotificationMarkReadRequestEntity extends BaseApiRequestModel {
    NotificationId?: string;
}